// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "数据库原理与应用",
      "tec": "马晟",
      "week": "6-17周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "Web前端开发技术",
      "tec": "关颖",
      "week": "6-13周",
      "add": "实训楼F座608信机"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "就业创业指导",
      "tec": "樊光瑞",
      "week": "10-14周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "2": [
    {
      "sub": "基础英语（一）",
      "tec": "薛旸",
      "week": "6-17周",
      "add": "实训楼F座302信息"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "王壮志",
      "week": "6-17周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "Java程序设计",
      "tec": "衣云龙",
      "week": "6-17周",
      "add": "教学楼C座402管理"
    },
    {
      "sub": "计算机组成原理",
      "tec": "王健",
      "week": "6-13周",
      "add": "实训楼F座301信息"
    },
    0
  ],
  "3": [
    {
      "sub": "Web前端开发技术",
      "tec": "关颖",
      "week": "6-13周",
      "add": "实训楼F座608信机"
    },
    {
      "sub": "数据库原理与应用",
      "tec": "马晟",
      "week": "6-17周",
      "add": "实训楼F座402信息"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "7-10周",
      "add": "教学楼C座210教务"
    }
  ],
  "4": [
    {
      "sub": "高等数学基础（一）",
      "tec": "王壮志",
      "week": "6-17双周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "基础英语（一）",
      "tec": "薛旸",
      "week": "7,9,11,13,15,17周",
      "add": "实训楼F座302信息"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "张文强",
      "week": "8-16周",
      "add": "教学楼B座325能动"
    },
    0
  ],
  "5": [
    {
      "sub": "计算机组成原理",
      "tec": "王健",
      "week": "6-13周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "Java程序设计",
      "tec": "衣云龙",
      "week": "6-17周",
      "add": "实训楼F座301信息"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼A座422机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
